<template>
  <q-form @submit="this.onSubmit" class="form">
    <div class="form__item">
      <CustomInput
        label="Название задачи"
        type="text"
        :required="true"
        :value="formData.task_name"
        @change_input="(value) => onChange('task_name', value)"
        autofocus
        style="width: 100%;"
      />
    </div>
    <div class="form__item">
      <CustomSelect
        :options="unitsOptions"
        label="Единица измерения"
        optionValueKey="unit_id"
        optionLabelKey="unit_name"
        placeholder="Выберите единицу измерения"
        :value="formData.unit_id || ''"
        @change="(value) => onChange('unit_id', value)"
        style="width: 100%;"
        :loading="unitsLoading"
        :clearable="true"
      />
    </div>
    <div class="form__item">
      <CustomInput
        label="Порядок сортировки"
        type="number"
        :value="formData.order_num"
        @change_input="(value) => onChange('order_num', value ? parseInt(value) : null)"
        style="width: 100%;"
      />
    </div>
    <CustomModalFooter :btn-loading="this.loading" />
  </q-form>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { getUnits } from "@/views/TierWorkGroup/services";

export default {
  name: "AddTaskDict",
  components: { CustomInput, CustomSelect, CustomModalFooter },
  props: ['data', 'closeModal'],
  data() {
    return {
      loading: false,
      unitsOptions: [],
      unitsLoading: false,
      formData: {
        task_dict_id: this.data?.task?.task_dict_id || null,
        work_group_dict_id: this.data?.workGroupDictId || null,
        task_name: this.data?.task?.task_name || '',
        unit_id: this.data?.task?.unit_id || null,
        order_num: this.data?.task?.order_num || null,
        is_edit: this.data?.task?.is_edit !== undefined ? this.data?.task?.is_edit : true,
        task_dict_code: this.data?.task?.task_dict_code || '',
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async getUnitsOptions() {
      this.unitsLoading = true
      const res = await getUnits();
      this.unitsLoading = false
      if (!res) return
      this.unitsOptions = res;
    },
    async onSubmit() {
      if (!this.formData.task_name || !this.formData.task_name.trim()) {
        return;
      }
      if (!this.formData.work_group_dict_id) {
        return;
      }
      this.loading = true
      const res = await this.data?.onSubmit(this.formData)
      this.loading = false
      if (res !== false) {
        this.closeModal?.()
      }
    },
  },
  mounted() {
    this.getUnitsOptions()
  }
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  width: 400px;
  gap: 15px;

  &__item {
    width: 100%;
    display: flex;
    gap: 16px;

    :deep(.custom-input) {
      width: 100%;
      max-width: 100%;
    }

    :deep(.custom-select) {
      width: 100%;
      max-width: 100%;
    }
  }

  @media (max-width: 460px) {
    width: 100%;
  }
}
</style>

